import { isEmpty } from './getValidator';

const applyParseJsonString = (parseFailureWarningMessage: string) => (jsonString?: string) => {
  if (isEmpty(jsonString)) {
    return undefined;
  }
  try {
    const jsonData = JSON.parse(jsonString!);
    if (typeof jsonData !== 'object') {
      console.warn(parseFailureWarningMessage);
      return undefined;
    } else if (!Object.keys(jsonData).length) {
      return undefined;
    } else {
      return jsonData;
    }
  } catch {
    console.warn(parseFailureWarningMessage);
    return undefined;
  }
};

export const parseStringValue = (valueKey?: string) => {
  if (valueKey === null || valueKey === undefined) {
    return undefined;
  } else if (valueKey === '') {
    return null; // Removes any previous set value from the session
  } else {
    return valueKey;
  }
};

export const parseCustomData = applyParseJsonString('custom-data must be a JSON object. Not submitting to API.');

export const parsePreferredCollectionPoint = applyParseJsonString(
  'preferred-collection-point must be a JSON object. Not submitting to API.'
);
